import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Swal from "sweetalert2";
import ImgCrop from "antd-img-crop";
import { Select, Upload } from "antd";
import { IMG_HOST } from "../../helper/host";
import { Settings, User } from "react-feather";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import eyeIcon from "../../assets/icons/eye.svg";
import eyeIconSlash from "../../assets/icons/eye-slash-grey.svg";
import "../styling.css"
import {connect} from "react-redux";
import UploadIcon from "../../assets/icons/import-icon-blue-light.svg";
import {withTourGuide} from "../guideComponent/withTourGuide";

export class Edit_karyawan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prosesSimpan: false,
            jabatan: [],
            lokasi: [],
            fileList: [],
            fileKtp: [],
            fileSelfie: [],
            fileIjazah: [],
            data_karyawan: [],
            divisi: [],
            perusahaan_karyawan: '',
            foto_karyawan: '',
            foto_ktp: '',
            foto_selfie: '',
            foto_ijazah: '',
            nama_karyawan: '',
            no_induk_karyawan: '',
            gender_karyawan: '',
            jabatan_karyawan: '',
            divisi_karyawan: '',
            lokasi_karyawan: null,
            lokasi_karyawanData: '',
            email_karyawan: '',
            password_karyawan: '',
            ttl_karyawan: '',
            join_date_karyawan: '',
            no_hp_karyawan: '',
            alamat_karyawan: '',
            gaji_karyawan: '',
            no_npwp: '',
            no_bpjs: '',
            hidePassword: false,
            hideConfirmPassword: false,
        }
        this.handleChange = this.handleChange.bind(this)
        this.validate = this.validate.bind(this)
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        showGuide(target, config);
    };

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }

    handlePressChange(event) {


        let formData = {
            karyawan_slug : this.props.match.params.karyawan_slug,
        }

        this.props.request('karyawan/ubah-status', formData, 'POST')
            .then((response) => {
                if (response.success) {
                    toast['success'](response.message)
                    this.loadDataKaryawan()
                }
                else {
                    if (Array.isArray(response.message)) {

                        response.message.map(item => {
                            toast['error'](item)
                            return true
                        })
                    } else {
                        toast['error'](response.message)
                    }
                }
            })
    }

    loadJabatan() {
        let form = {}
        this.props.request("get_jabatan_perusahaan", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        jabatan: response.data,
                    })
                }
            });
    }



    loadLokasi() {
        let form = {}
        this.props.request("get_lokasi_perusahaan", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        lokasi: response.data,
                    })
                }
            });
    }
    lokasiHandler = () => {
        if (this.state.lokasi_karyawan === null) {
            if (this.state.lokasi_karyawanData !== null) {
                this.setState({
                    lokasi_karyawan: this.state.lokasi_karyawanData
                })
            } else {
                this.setState({
                    lokasi_karyawan: "" + this.state.lokasi[0].lokasi_id + ""
                })
            }
        } else {
            this.setState({
                lokasi_karyawan: null
            })
        }
    }

    validate(name, value) {
        let errorsMessage = this.state.errorsMessage

        switch (name) {
            case 'password_baru':
                if (value.trim() === '') {
                    errorsMessage[name] = 'Password Baru harus diisi!'
                } else if (this.props.password_baru !== '') {
                    if (value !== this.props.confirm_password) {
                        errorsMessage.password_baru = 'Password yang anda masukan berbeda!'
                    } else {
                        delete errorsMessage.password_baru
                    }
                } else {
                    delete errorsMessage[name]
                }
                break
            case 'confirm_password':
                if (this.props.confirm_password.trim() !== '' && value.trim() === '') {
                    errorsMessage[name] = 'Konfirmasi Password Baru harus diisi!'
                } else if (this.props.confirm_password.trim() !== '' && value !== this.props.password_baru) {
                    errorsMessage[name] = 'Password yang anda masukkan berbeda!'
                } else {
                    delete errorsMessage[name]
                }
                break
            default:
                errorsMessage = this.state.errorsMessage
        }

        this.setState({
            errorsMessage,
            disabledButtonErr: Object.keys(this.state.errorsMessage).length > 0 ? true : false
        })
    }

    simpanKaryawan = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            karyawan_id: this.props.match.params.karyawan_slug,
            lokasi_karyawan: this.state.lokasi_karyawan,
            foto_karyawan: this.state.foto_karyawan === null ? this.state.data_karyawan.karyawan_foto : this.state.foto_karyawan,
            foto_ktp: this.state.foto_ktp === null ? this.state.data_karyawan.karyawan_ktp : this.state.foto_ktp,
            foto_selfie: this.state.foto_selfie === null ? this.state.data_karyawan.karyawan_selfie : this.state.foto_selfie,
            foto_ijazah: this.state.foto_ijazah === null ? this.state.data_karyawan.karyawan_selfie : this.state.foto_ijazah,
            nama_karyawan: this.state.nama_karyawan,
            no_induk_karyawan: this.state.no_induk_karyawan,
            gender_karyawan: this.state.gender_karyawan,
            email_karyawan: this.state.email_karyawan,
            jabatan_karyawan: this.state.jabatan_karyawan,
            divisi_karyawan: this.state.divisi_karyawan,
            ttl_karyawan: this.state.ttl_karyawan,
            join_date_karyawan: this.state.join_date_karyawan,
            no_hp_karyawan: this.state.no_hp_karyawan,
            alamat_karyawan: this.state.alamat_karyawan,
            no_npwp: this.state.no_npwp,
            no_bpjs: this.state.no_bpjs,
            outlet: this.state.pilih_outlet
        }
        this.props.request("karyawan/update_karyawan", form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.success,
                        icon: 'success'
                    })
                    this.props.history.push('/karyawan/list-karyawan/' + this.props.match.params.page)
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.failed,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }

    simpanPasswordKaryawan = () => {
        this.setState({
            prosesSimpan: true,
        })

        let form = {
            id_karyawan: this.props.match.params.karyawan_slug,
            perusahaan_id : this.props.user.perusahaan.perusahaan_id,
            password_baru: this.state.password_baru,
            confirm_password: this.state.confirm_password,
        }

        this.props.request("karyawan/update_password_karyawan", form)
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                    this.props.history.push('/karyawan/list-karyawan/' + this.props.match.params.page)
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                })
            });
    }

    loadDivisi() {
        let form = {}
        this.props.request("get_divisi_perusahaan", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        isLoading: false,
                        divisi: response.data
                    })
                }
            });
    }

    loadDataKaryawan() {
        let form = {
            karyawan_slug : this.props.match.params.karyawan_slug
        }
        this.props.request("karyawan/get_karyawan_by_slug", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        data_karyawan: response.data,
                        jabatan_karyawan: response.data.jabatan_id,
                        divisi_karyawan: response.data.divisi_id,
                        lokasi_karyawan: response.data.lokasi_id,
                        lokasi_karyawanData: response.data.lokasi_id,
                        nama_karyawan: response.data.karyawan_nama,
                        no_induk_karyawan: response.data.karyawan_no_induk,
                        gender_karyawan: response.data.karyawan_gender,
                        foto_karyawan: response.data.karyawan_foto,
                        foto_ktp: response.data.karyawan_ktp,
                        foto_selfie: response.data.karyawan_selfie,
                        foto_ijazah: response.data.karyawan_ijazah,
                        email_karyawan: response.data.karyawan_email,
                        ttl_karyawan: response.data.karyawan_ttl,
                        join_date_karyawan: response.data.join_date_karyawan,
                        no_hp_karyawan: response.data.no_hp,
                        no_npwp: response.data.karyawan_no_npwp,
                        no_bpjs: response.data.karyawan_no_bpjs,
                        alamat_karyawan: response.data.karyawan_alamat,

                    })
                    if (response.data.karyawan_foto !== null) {
                        this.setState({
                            fileList: [
                                {
                                    uid: "-1",
                                    name: response.data.karyawan_foto,
                                    status: "done",
                                    url: IMG_HOST + 'frontapp/karyawan/' + response.data.karyawan_foto
                                }
                            ],
                        })
                    }

                    if (response.data.karyawan_selfie !== null) {
                        this.setState({
                            fileSelfie: [
                                {
                                    uid: "-1",
                                    name: response.data.karyawan_selfie,
                                    status: "done",
                                    url: IMG_HOST + 'frontapp/karyawan/' + response.data.karyawan_selfie
                                }
                            ],
                        })
                    }

                    if (response.data.karyawan_ktp !== null) {
                        this.setState({
                            fileKtp: [
                                {
                                    uid: "-1",
                                    name: response.data.karyawan_ktp,
                                    status: "done",
                                    url: IMG_HOST + 'frontapp/karyawan/' + response.data.karyawan_ktp
                                }
                            ],
                        })
                    }
                    if (response.data.karyawan_ijazah !== null) {
                        this.setState({
                            fileIjazah: [
                                {
                                    uid: "-1",
                                    name: response.data.karyawan_ijazah,
                                    status: "done",
                                    url: IMG_HOST + 'frontapp/karyawan/' + response.data.karyawan_ijazah
                                }
                            ],
                        })
                    }
                }
            });
    }

    componentDidMount() {
        this.loadLokasi()
        this.loadJabatan()
        this.loadDivisi()
        this.loadDataKaryawan()
    }

    render() {
        const { Option } = Select;
        const { divisi, jabatan } = this.state;

        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Edit Karyawan - Presensi</title>
                    <meta name="description" content="Detail Absensi" />
                </Helmet>
                <Breadcrumb title="Edit Karyawan" parent="Karyawan" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Edit Karyawan</h5>
                                </div>
                                <div className="card-body">
                                    <Tabs>
                                        <TabList className="nav nav-tabs tab-coupon">
                                            <Tab className="nav-link d-flex align-items-center"><User className="mr-2" style={{ width: 20, height: 20 }}/><b>Detail Karyawan</b></Tab>
                                            <Tab className="nav-link d-flex align-items-center"><Settings className="mr-2" style={{ width: 20, height: 20 }}/><b>Ganti Password</b></Tab>
                                        </TabList>

                                        <TabPanel>
                                            <form className="needs-validation user-add" noValidate="">
                                                <div className="tab-pane fade show active">
                                                    <div className="form-group row col-md-12">
                                                        <div className="col-lg-3 col-md-6"
                                                             onPointerEnter={(e) => {
                                                                 this.triggerGuideOnce(e, {
                                                                     key: "uploadFotoKaryawan",
                                                                     title: "Foto Karyawan",
                                                                     content: "Upload foto resmi karyawan. Ukuran ideal 750x1000px (portrait). Klik 'Cari Gambar' untuk memilih file dari perangkat Anda."
                                                                 });
                                                             }}
                                                        >
                                                            <ImgCrop
                                                                rotate
                                                                width={750}
                                                                height={1000}>
                                                                <Upload customRequest={({file, onSuccess}) => {
                                                                    setTimeout(() => {
                                                                        onSuccess("ok");
                                                                    }, 0);
                                                                }}
                                                                        listType="picture-card"
                                                                        fileList={this.state.fileList}
                                                                        className="antd-upload-custom"
                                                                        onRemove={() => {
                                                                            this.setState({foto_karyawan: null})
                                                                        }}
                                                                        onChange={(file) => {
                                                                            this.setState({fileList: file.fileList})

                                                                            if (file.fileList.length > 0) {
                                                                                let files = file.file.originFileObj
                                                                                let reader = new FileReader()

                                                                                reader.readAsDataURL(files)
                                                                                reader.onloadend = () => {
                                                                                    this.setState({
                                                                                        foto_karyawan: {
                                                                                            name: file.file.name,
                                                                                            file: reader.result
                                                                                        }
                                                                                    })
                                                                                }
                                                                            } else {
                                                                                this.setState({foto_karyawan: []})
                                                                            }
                                                                        }}
                                                                >
                                                                    {this.state.fileList.length >= 1 ? null :
                                                                        <div
                                                                            className="p-2 d-flex align-items-center justify-content-center flex-column"
                                                                            style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon}
                                                                         style={{height: "24px", width: "24px"}}/>
                                                                </span>
                                                                            <p className="ant-upload-text mb-3" style={{
                                                                                fontSize: "12px",
                                                                                fontWeight: 400,
                                                                                lineHeight: "16px",
                                                                                marginTop: "6px"
                                                                            }}>Upload foto karyawan</p>
                                                                            <a className="btn btn-outline-custom tambah-karyawan">Cari
                                                                                Gambar</a>
                                                                        </div>
                                                                    }
                                                                </Upload>
                                                            </ImgCrop>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6"
                                                             onPointerEnter={(e) => {
                                                                 this.triggerGuideOnce(e, {
                                                                     key: "uploadFotoSelfie",
                                                                     title: "Foto Selfie Karyawan",
                                                                     content: "Upload foto selfie karyawan untuk keperluan verifikasi absensi wajah. Pastikan wajah terlihat jelas."
                                                                 });
                                                             }}>
                                                            <ImgCrop
                                                                rotate
                                                                width={550}
                                                                height={860}>
                                                                <Upload customRequest={({file, onSuccess}) => {
                                                                    setTimeout(() => {
                                                                        onSuccess("ok");
                                                                    }, 0);
                                                                }}
                                                                        listType="picture-card"
                                                                        fileList={this.state.fileSelfie}
                                                                        className="antd-upload-custom"
                                                                        onRemove={() => {
                                                                            this.setState({foto_selfie: null})
                                                                        }}
                                                                        onChange={(file) => {
                                                                            this.setState({fileSelfie: file.fileList})

                                                                            if (file.fileList.length > 0) {
                                                                                let files = file.file.originFileObj
                                                                                let reader = new FileReader()

                                                                                reader.readAsDataURL(files)
                                                                                reader.onloadend = () => {
                                                                                    this.setState({
                                                                                        foto_selfie: {
                                                                                            name: file.file.name,
                                                                                            file: reader.result
                                                                                        }
                                                                                    })
                                                                                }
                                                                            } else {
                                                                                this.setState({foto_selfie: []})
                                                                            }
                                                                        }}
                                                                >
                                                                    {this.state.fileSelfie.length >= 1 ? null :
                                                                        <div
                                                                            className="p-2 d-flex flex-column align-items-center justify-content-center"
                                                                            style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon}
                                                                         style={{height: "24px", width: "24px"}}/>
                                                                </span>
                                                                            <p className="ant-upload-text mb-3" style={{
                                                                                fontSize: "12px",
                                                                                fontWeight: 400,
                                                                                lineHeight: "16px",
                                                                                marginTop: "6px"
                                                                            }}>Upload foto selfie karyawan</p>
                                                                            <a className="btn btn-outline-custom tambah-karyawan">Cari
                                                                                Gambar</a>
                                                                        </div>
                                                                    }
                                                                </Upload>
                                                            </ImgCrop>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6"
                                                             onPointerEnter={(e) => {
                                                                 this.triggerGuideOnce(e, {
                                                                     key: "uploadFotoKtp",
                                                                     title: "Foto KTP Karyawan",
                                                                     content: "Upload foto KTP karyawan dengan ukuran ideal 960x480px (landscape). Pastikan seluruh teks pada KTP terbaca dengan jelas."
                                                                 });
                                                             }}>
                                                            <ImgCrop
                                                                rotate
                                                                width={960}
                                                                height={480}>
                                                                <Upload customRequest={({file, onSuccess}) => {
                                                                    setTimeout(() => {
                                                                        onSuccess("ok");
                                                                    }, 0);
                                                                }}
                                                                        listType="picture-card"
                                                                        fileList={this.state.fileKtp}
                                                                        className="antd-upload-custom"
                                                                        onRemove={() => {
                                                                            this.setState({foto_ktp: null})
                                                                        }}
                                                                        onChange={(file) => {
                                                                            this.setState({fileKtp: file.fileList})

                                                                            if (file.fileList.length > 0) {
                                                                                let files = file.file.originFileObj
                                                                                let reader = new FileReader()

                                                                                reader.readAsDataURL(files)
                                                                                reader.onloadend = () => {
                                                                                    this.setState({
                                                                                        foto_ktp: {
                                                                                            name: file.file.name,
                                                                                            file: reader.result
                                                                                        }
                                                                                    })
                                                                                }
                                                                            } else {
                                                                                this.setState({foto_ktp: []})
                                                                            }
                                                                        }}
                                                                >
                                                                    {this.state.fileKtp.length >= 1 ? null :
                                                                        <div
                                                                            className="p-2 d-flex flex-column align-items-center justify-content-center"
                                                                            style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon}
                                                                         style={{height: "24px", width: "24px"}}/>
                                                                </span>
                                                                            <p className="ant-upload-text mb-3" style={{
                                                                                fontSize: "12px",
                                                                                fontWeight: 400,
                                                                                lineHeight: "16px",
                                                                                marginTop: "6px"
                                                                            }}>Upload foto KTP karyawan</p>
                                                                            <a className="btn btn-outline-custom tambah-karyawan">Cari
                                                                                Gambar</a>
                                                                        </div>
                                                                    }
                                                                </Upload>
                                                            </ImgCrop>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6"
                                                             onPointerEnter={(e) => {
                                                                 this.triggerGuideOnce(e, {
                                                                     key: "uploadFotoIjazah",
                                                                     title: "Foto Ijazah & Sertifikat",
                                                                     content: "Upload foto ijazah atau sertifikat pendidikan terakhir karyawan sebagai dokumen pendukung."
                                                                 });
                                                             }}>
                                                            <ImgCrop
                                                                rotate
                                                                width={550}
                                                                height={860}>
                                                                <Upload customRequest={({file, onSuccess}) => {
                                                                    setTimeout(() => {
                                                                        onSuccess("ok");
                                                                    }, 0);
                                                                }}
                                                                        listType="picture-card"
                                                                        fileList={this.state.fileIjazah}
                                                                        className="antd-upload-custom"
                                                                        onRemove={() => {
                                                                            this.setState({foto_ijazah: null})
                                                                        }}
                                                                        onChange={(file) => {
                                                                            this.setState({fileIjazah: file.fileList})

                                                                            if (file.fileList.length > 0) {
                                                                                let files = file.file.originFileObj
                                                                                let reader = new FileReader()

                                                                                reader.readAsDataURL(files)
                                                                                reader.onloadend = () => {
                                                                                    this.setState({
                                                                                        foto_ijazah: {
                                                                                            name: file.file.name,
                                                                                            file: reader.result
                                                                                        }
                                                                                    })
                                                                                }
                                                                            } else {
                                                                                this.setState({foto_ijazah: []})
                                                                            }
                                                                        }}
                                                                >
                                                                    {this.state.fileIjazah.length >= 1 ? null :
                                                                        <div
                                                                            className="p-2 d-flex align-items-center justify-content-center flex-column"
                                                                            style={{height: "167px"}}>
                                                                <span>
                                                                    <img src={UploadIcon}
                                                                         style={{height: "24px", width: "24px"}}/>
                                                                </span>
                                                                            <p className="ant-upload-text mb-3" style={{
                                                                                fontSize: "12px",
                                                                                fontWeight: 400,
                                                                                lineHeight: "16px",
                                                                                marginTop: "6px"
                                                                            }}>Upload foto ijazah dan sertifikat</p>
                                                                            <a className="btn btn-outline-custom tambah-karyawan">Cari
                                                                                Gambar</a>
                                                                        </div>
                                                                    }
                                                                </Upload>
                                                            </ImgCrop>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Nama
                                                                    Karyawan</label>
                                                                <input name="nama_karyawan"
                                                                       className="form-control"
                                                                       placeholder="Nama Karyawan..."
                                                                       type="text" required=""
                                                                       defaultValue={this.state.data_karyawan.karyawan_nama}
                                                                       onChange={this.handleChange}
                                                                       onPointerEnter={(e) => {
                                                                           this.triggerGuideOnce(e, {
                                                                               key: "namaKaryawan",
                                                                               title: "Nama Karyawan",
                                                                               content: "Masukkan nama lengkap karyawan sesuai identitas resmi (KTP). Nama ini akan digunakan pada seluruh dokumen dan laporan."
                                                                           });
                                                                       }}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Nomor Induk
                                                                    Karyawan (Opsional)</label>
                                                                <input name="no_induk_karyawan"
                                                                       className="form-control"
                                                                       placeholder="No Induk Karyawan..."
                                                                       type="text" required=""
                                                                       defaultValue={this.state.data_karyawan.karyawan_no_induk}
                                                                       onChange={this.handleChange}
                                                                       onPointerEnter={(e) => {
                                                                           this.triggerGuideOnce(e, {
                                                                               key: "noIndukKaryawan",
                                                                               title: "Nomor Induk Karyawan (NIK)",
                                                                               content: "Isi dengan nomor induk karyawan internal perusahaan. Field ini bersifat opsional, namun disarankan untuk memudahkan identifikasi karyawan."
                                                                           });
                                                                       }}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Email</label>
                                                                <input name="email_karyawan"
                                                                       className="form-control "
                                                                       placeholder="Email Karyawan..."
                                                                       type="email" required=""
                                                                       defaultValue={this.state.data_karyawan.karyawan_email}
                                                                       onChange={this.handleChange}
                                                                       onPointerEnter={(e) => {
                                                                           this.triggerGuideOnce(e, {
                                                                               key: "emailKaryawan",
                                                                               title: "Email Karyawan",
                                                                               content: "Masukkan alamat email aktif karyawan. Email ini digunakan untuk login ke sistem dan menerima notifikasi penting."
                                                                           });
                                                                       }}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">No.
                                                                    Handphone</label>
                                                                <input name="no_hp_karyawan"
                                                                       className="form-control "
                                                                       type="number" required=""
                                                                       placeholder="No. HP Karyawan..."
                                                                       defaultValue={this.state.data_karyawan.no_hp}
                                                                       onChange={this.handleChange}
                                                                       onPointerEnter={(e) => {
                                                                           this.triggerGuideOnce(e, {
                                                                               key: "noHpKaryawan",
                                                                               title: "Nomor Handphone",
                                                                               content: "Masukkan nomor HP aktif karyawan. Nomor ini dapat digunakan untuk keperluan komunikasi dan verifikasi akun."
                                                                           });
                                                                       }}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Alamat</label>
                                                                <input name="alamat_karyawan" type="text"
                                                                       className="form-control "
                                                                       defaultValue={this.state.data_karyawan.karyawan_alamat}
                                                                       onChange={this.handleChange}
                                                                       onPointerEnter={(e) => {
                                                                           this.triggerGuideOnce(e, {
                                                                               key: "alamatKaryawan",
                                                                               title: "Alamat Karyawan",
                                                                               content: "Isi dengan alamat domisili karyawan saat ini. Informasi ini digunakan untuk keperluan administrasi dan surat-menyurat."
                                                                           });
                                                                       }}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Nomor Pokok
                                                                    Wajib Pajak (Opsional)</label>
                                                                <input maxLength={16} name="no_npwp" type="text"
                                                                       className="form-control"
                                                                       defaultValue={this.state.data_karyawan.karyawan_no_npwp}
                                                                       onChange={this.handleChange}
                                                                       onPointerEnter={(e) => {
                                                                           this.triggerGuideOnce(e, {
                                                                               key: "npwpKaryawan",
                                                                               title: "Nomor Pokok Wajib Pajak (NPWP)",
                                                                               content: "Isi dengan nomor NPWP karyawan (maksimal 16 digit). Field ini opsional, namun diperlukan untuk keperluan pelaporan pajak penghasilan."
                                                                           });
                                                                       }}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">No. BPJS
                                                                    (Opsional)</label>
                                                                <input maxLength={16} name="no_bpjs" type="text"
                                                                       className="form-control"
                                                                       defaultValue={this.state.data_karyawan.karyawan_no_bpjs}
                                                                       onChange={this.handleChange}
                                                                       onPointerEnter={(e) => {
                                                                           this.triggerGuideOnce(e, {
                                                                               key: "bpjsKaryawan",
                                                                               title: "Nomor BPJS",
                                                                               content: "Masukkan nomor kartu BPJS Kesehatan atau BPJS Ketenagakerjaan karyawan (maksimal 16 digit). Bersifat opsional."
                                                                           });
                                                                       }}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="row">
                                                                <div className="col-6 form-group">
                                                                    <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                           className="mb-2 font-weight-bold">Tanggal
                                                                        Lahir</label>
                                                                    <input name="ttl_karyawan"
                                                                           defaultValue={this.state.data_karyawan.karyawan_ttl}
                                                                           className="form-control"
                                                                           onChange={this.handleChange}
                                                                           type="date" required=""
                                                                           onPointerEnter={(e) => {
                                                                               this.triggerGuideOnce(e, {
                                                                                   key: "ttlKaryawan",
                                                                                   title: "Tanggal Lahir",
                                                                                   content: "Isi tanggal lahir karyawan sesuai KTP. Data ini digunakan untuk perhitungan usia dan keperluan administrasi HR."
                                                                               });
                                                                           }}/>
                                                                </div>
                                                                <div className="col-6 form-group">
                                                                    <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                           className="mb-2 font-weight-bold">Jenis
                                                                        Kelamin Karyawan</label>
                                                                    <div className="mt-2"
                                                                         onPointerEnter={(e) => {
                                                                             this.triggerGuideOnce(e, {
                                                                                 key: "genderKaryawan",
                                                                                 title: "Jenis Kelamin",
                                                                                 content: "Pilih jenis kelamin karyawan. Informasi ini digunakan untuk keperluan data demografis dan administrasi perusahaan."
                                                                             });
                                                                         }}>
                                                                        <div className="form-check form-check-inline">
                                                                            <input className="form-check-input"
                                                                                   type="radio"
                                                                                   checked={this.state.gender_karyawan === "Laki-laki"}
                                                                                   onClick={(e) => this.setState({gender_karyawan: e.target.value})}
                                                                                   name="inlineRadioOptions"
                                                                                   id="inlineRadio1" value="Laki-laki"/>
                                                                            <label className="form-check-label"
                                                                                   style={{fontSize: "12px"}}
                                                                                   htmlFor="inlineRadio1">Laki-Laki</label>
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <input className="form-check-input"
                                                                                   type="radio"
                                                                                   name="inlineRadioOptions"
                                                                                   id="inlineRadio2"
                                                                                   onClick={(e) => this.setState({gender_karyawan: e.target.value})}
                                                                                   checked={this.state.gender_karyawan === "Perempuan"}
                                                                                   value="Perempuan"/>
                                                                            <label className="form-check-label"
                                                                                   style={{fontSize: "12px"}}
                                                                                   htmlFor="inlineRadio2">Perempuan</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6 form-group">
                                                                    <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                           className="mb-2 font-weight-bold">Tanggal
                                                                        Mulai Kerja Karyawan</label>
                                                                    <input name="join_date_karyawan"
                                                                           defaultValue={this.state.data_karyawan.karyawan_join_date}
                                                                           className="form-control"
                                                                           onChange={this.handleChange}
                                                                           type="date" required=""
                                                                           onPointerEnter={(e) => {
                                                                               this.triggerGuideOnce(e, {
                                                                                   key: "joinDateKaryawan",
                                                                                   title: "Tanggal Mulai Kerja",
                                                                                   content: "Isi dengan tanggal pertama karyawan mulai bekerja di perusahaan. Data ini digunakan untuk menghitung masa kerja dan hak cuti."
                                                                               });
                                                                           }}/>
                                                                </div>
                                                                <div className="col-6 form-group">
                                                                    <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                           className="mb-2 font-weight-bold">Status</label>
                                                                    <div className="d-flex align-items-center mt-2"
                                                                         onPointerEnter={(e) => {
                                                                             this.triggerGuideOnce(e, {
                                                                                 key: "statusKaryawan",
                                                                                 title: "Status Karyawan",
                                                                                 content: "Pilih status aktif atau non-aktif karyawan. Karyawan non-aktif tidak dapat melakukan absensi dan tidak muncul pada laporan aktif."
                                                                             });
                                                                         }}>
                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                name="status_karyawan"
                                                                                id="active"
                                                                                type="radio"
                                                                                value="active"
                                                                                checked={this.state.data_karyawan.status_karyawan === "active"}
                                                                                onClick={(event) => this.handlePressChange(event)}
                                                                            />
                                                                            <label className="form-check-label ml-1"
                                                                                   style={{fontSize: "12px"}}
                                                                                   htmlFor="inlineRadio1">Active</label>
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                name="status_karyawan"
                                                                                type="radio"
                                                                                value="non-active"
                                                                                checked={this.state.data_karyawan.status_karyawan === "non-active"}
                                                                                onClick={(event) => this.handlePressChange(event)}
                                                                            />
                                                                            <label className="form-check-label ml-1"
                                                                                   style={{fontSize: "12px"}}
                                                                                   htmlFor="inlineRadio2">Non-Active</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Divisi
                                                                    Karyawan</label>
                                                                <select name="divisi_karyawan"
                                                                        className="form-control"
                                                                        onChange={this.handleChange}
                                                                        onPointerEnter={(e) => {
                                                                            this.triggerGuideOnce(e, {
                                                                                key: "divisiKaryawan",
                                                                                title: "Divisi Karyawan",
                                                                                content: "Pilih divisi tempat karyawan bertugas. Divisi mengelompokkan karyawan berdasarkan departemen atau bagian dalam struktur organisasi."
                                                                            });
                                                                        }}>
                                                                    <option>Pilih Divisi Karyawan</option>
                                                                    {divisi.map((item, index) => {
                                                                        return (
                                                                            <option value={item.divisi_id}
                                                                                    selected={this.state.data_karyawan.divisi_id === item.divisi_id}>{item.divisi_name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Jabatan
                                                                    Karyawan</label>
                                                                <select name="jabatan_karyawan"
                                                                        className="form-control"
                                                                        onChange={this.handleChange}
                                                                        onPointerEnter={(e) => {
                                                                            this.triggerGuideOnce(e, {
                                                                                key: "jabatanKaryawan",
                                                                                title: "Jabatan Karyawan",
                                                                                content: "Pilih jabatan atau posisi karyawan dalam perusahaan. Jabatan menentukan hak akses dan struktur hierarki organisasi."
                                                                            });
                                                                        }}>
                                                                    <option>Pilih Jabatan Karyawan</option>
                                                                    {jabatan.map((item, index) => {
                                                                        return (
                                                                            <option value={item.jabatan_id}
                                                                                    selected={this.state.data_karyawan.jabatan_id === item.jabatan_id}>{item.jabatan_nama}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                            </div>
                                                            <div className="form-group">
                                                                <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                       className="mb-2 font-weight-bold">Lokasi Absen
                                                                    Karyawan</label>
                                                                <div className=""
                                                                     onPointerEnter={(e) => {
                                                                         this.triggerGuideOnce(e, {
                                                                             key: "lokasiKaryawan",
                                                                             title: "Lokasi Absen Karyawan",
                                                                             content: "Tentukan lokasi absensi yang diizinkan untuk karyawan. Centang 'Semua Lokasi' agar karyawan bisa absen di seluruh lokasi perusahaan, atau pilih lokasi spesifik."
                                                                         });
                                                                     }}>
                                                                    <label htmlFor="all_location" className="d-flex align-items-center" style={{ fontSize: 12 }}>
                                                                        <input type="checkbox" id="all_location"
                                                                               checked={this.state.lokasi_karyawan === null}
                                                                               onChange={() => this.lokasiHandler()}/>
                                                                        &nbsp;Semua Lokasi Perusahaan
                                                                    </label>

                                                                    {this.state.lokasi_karyawan !== null &&
                                                                        <Select name="lokasi_karyawan"
                                                                                style={{width: '100%'}}
                                                                                value={this.state.lokasi_karyawan}
                                                                                mode={"multiple"}
                                                                                placeholder="Pilih Lokasi"
                                                                                filterOption={(input, option) =>
                                                                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                    || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                }
                                                                                onChange={(event) => {
                                                                                    this.setState({
                                                                                        lokasi_karyawan: event
                                                                                    })
                                                                                }}>
                                                                            {this.state.lokasi.map((item, index) => {
                                                                                return (
                                                                                    <Option
                                                                                        key={item.lokasi_id}>{item.lokasi_nama}</Option>)
                                                                            })}
                                                                        </Select>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            <div className="pull-right">
                                                <a className='btn btn-outline-secondary mr-2 text-capitalize' href="/karyawan/list-karyawan/0">Batalkan</a>
                                                {this.state.prosesSimpan === false ?
                                                    <button type="button" className="btn btn-primary"
                                                            onClick={this.simpanKaryawan}>Simpan</button>
                                                    :
                                                    <button type="button" className="btn btn-primary"><i
                                                        className="fa fa-refresh fa-spin"></i> Loading</button>
                                                }
                                            </div>
                                        </TabPanel>
                                        <TabPanel>
                                            <form className="needs-validation user-add" noValidate="">
                                                <div className="input-group row">
                                                    <label className="col-xl-3 col-md-4"><span className="text-danger">*</span>Password
                                                        Baru</label>
                                                    <input name="password_baru"
                                                           className="form-control col-xl-8 col-md-7"
                                                           placeholder="Password Baru Karyawan..."
                                                           type={this.state.hidePassword ? "text" : "password"}
                                                           required="" onChange={this.handleChange} onKeyDown={(e) => {
                                                                // if (e.key === "Enter") {
                                                                //     this.simpanPasswordKaryawan(e)
                                                                // }
                                                            }}
                                                           onPointerEnter={(e) => {
                                                               this.triggerGuideOnce(e, {
                                                                   key: "passwordBaru",
                                                                   title: "Password Baru",
                                                                   content: "Masukkan password baru untuk akun karyawan. Gunakan kombinasi huruf, angka, dan simbol minimal 8 karakter untuk keamanan yang lebih baik."
                                                               });
                                                           }}/>
                                                    <div className="input-group-append">
                                                        <div className="input-group-text" style={{ cursor: "pointer" }}>
                                                            <img className="show-hide-button" style={{
                                                                width: "16px",
                                                                height: "16px",
                                                                backgroundColor: "#E9ECEF"
                                                            }} src={this.state.hidePassword ? eyeIcon : eyeIconSlash}
                                                                 onClick={() => this.setState({
                                                                     hidePassword: !this.state.hidePassword
                                                                 })}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br/>
                                                <div className="input-group row">
                                                    <label className="col-xl-3 col-md-4"><span className="text-danger">*</span>Konfirmasi Password
                                                        Baru</label>
                                                    <input name="confirm_password"
                                                           className="form-control col-xl-8 col-md-7"
                                                           placeholder="Konfirmasi Password Baru Karyawan..."
                                                           type={this.state.hideConfirmPassword ? "text" : "password"}
                                                           required="" onChange={this.handleChange} onKeyDown={(e) => {
                                                                if (e.key === "Enter") {
                                                                    this.simpanPasswordKaryawan(e)
                                                                }
                                                            }}
                                                           onPointerEnter={(e) => {
                                                               this.triggerGuideOnce(e, {
                                                                   key: "confirmPassword",
                                                                   title: "Konfirmasi Password Baru",
                                                                   content: "Masukkan kembali password baru yang sama persis untuk memastikan tidak ada kesalahan pengetikan. Tekan Enter untuk langsung menyimpan."
                                                               });
                                                           }}/>
                                                    <div className="input-group-append">
                                                        <div className="input-group-text" style={{ cursor: "pointer" }}>
                                                            <img className="show-hide-button" style={{
                                                                width: "16px",
                                                                height: "16px",
                                                                backgroundColor: "#E9ECEF"
                                                            }} src={this.state.hideConfirmPassword ? eyeIcon : eyeIconSlash}
                                                                 onClick={() => this.setState({
                                                                     hideConfirmPassword: !this.state.hideConfirmPassword
                                                                 })}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            <div className="pull-right mt-4">
                                                <a className='btn btn-outline-secondary mr-2 text-capitalize'
                                                   href="/karyawan/list-karyawan/0">Batalkan</a>
                                                {this.state.prosesSimpan === false ?
                                                    <button type="button" className="btn btn-primary"
                                                            onClick={this.simpanPasswordKaryawan}>Simpan</button>
                                                    :
                                                    <button type="button" className="btn btn-primary"><i
                                                        className="fa fa-refresh fa-spin"></i> Loading</button>
                                                }
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    jabatan: state.Filter?._jabatan,
    divisi: state.Filter?._divisi
});


export default connect(mapStateToProps)(withTourGuide(Edit_karyawan));
